import { createContext, useContext, type ReactNode } from 'react'
import type { IssueRepository } from './IssueRepository'

const IssueRepositoryContext = createContext<IssueRepository | null>(null)

export interface IssueRepositoryProviderProps {
  repository: IssueRepository
  children: ReactNode
}

export function IssueRepositoryProvider({ repository, children }: IssueRepositoryProviderProps) {
  return (
    <IssueRepositoryContext.Provider value={repository}>
      {children}
    </IssueRepositoryContext.Provider>
  )
}

export function useIssueRepository(): IssueRepository {
  const repository = useContext(IssueRepositoryContext)
  if (!repository) {
    throw new Error('useIssueRepository must be used within an IssueRepositoryProvider')
  }
  return repository
}
